import { ExternalLink } from './ExternalLink';
import { websiteDisplay } from './social-format';
import { UnknownValue } from './UnknownValue';

/** The venue's website as a link, plain text if it is not a usable address, or "No website". */
export function SocialWebsite({ url }: { url: string | undefined }) {
  if (!url) return <UnknownValue>No website</UnknownValue>;
  const link = websiteDisplay(url);
  return link ? (
    <ExternalLink mono href={link.href}>
      {link.text}
    </ExternalLink>
  ) : (
    <span className="nb-mono">{url}</span>
  );
}
